<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-simple-table class="mt-3">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Violation ID</th>
            <th>Violations</th>
            <th>Assessment ID</th>
            <th>Assessment Date</th>
            <th>Route ID</th>
            <th>Route Name</th>
            <th>Vehicle Name</th>
            <th>Route Start</th>
            <th>Route End</th>
            <th>Email</th>
            <th>Cause</th>
            <th>Action</th>
            <th>Product OK</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="route in report.results">
            <td>{{ route.customer_name }}</td>
            <td>{{ route.violation_id }}</td>
            <td>{{ route.violation_type }}</td>
            <td>{{ route.assessment_id }}</td>
            <td>
              <multi-time-display
                v-if="route.assessment_created"
                :time="route.assessment_created"
                timeFormat="M/D/YYYY h:mm:ss A" />
              <span v-else>-</span>
            </td>
            <td>
              <router-link :to="`/route/${route.id}`">{{ route.id }}</router-link>
            </td>
            <td>
              <router-link :to="`/route/${route.id}`">{{ route.name }}</router-link>
            </td>
            <td>{{ route.vehicle_name }}</td>
            <td>
              <multi-time-display
                v-if="route.start"
                :time="route.start"
                timeFormat="M/D/YYYY h:mm:ss A" />
              <span v-else>-</span>
            </td>
            <td>
              <multi-time-display
                v-if="route.end"
                :time="route.end"
                timeFormat="M/D/YYYY h:mm:ss A" />
              <span v-else>-</span>
            </td>
            <td>{{ route.user_email }}</td>
            <td>{{ route.cause_value }}</td>
            <td>{{ route.action_value }}</td>
            <td>{{ route.product_ok }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ReportRecord from '@/orm/models/ReportRecord'
import Moment from 'moment'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import ReportMixin from '@/components/report/ReportMixin'

export default {
  name: 'RCA Report',
  components: {
    MultiTimeDisplay
  },
  mixins: [
    ReportMixin
  ],
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {
    }
  },
  computed: {
    weekDate () {
      return Moment(this.report.parameters.weekDate)
    },
    routeTarget () {
      return this.report.parameters.routeTarget
    },
    planTarget () {
      return this.report.parameters.planTarget
    },
    completionTarget () {
      return this.report.parameters.completionTarget
    }
  },
  methods: {
    getTargetClass (target, current) {
      return current < target ? 'text-danger' : 'text-success'
    }
  }
}
</script>

<style scoped lang="scss">
.table-header {
  font-size: 16px;
}
.divider {
  border-right: 1px solid #efefef;
}
.date-display {
  font-size: 18px;
}
</style>
